import React from 'react';
import { Sheet } from './AdminUi';

// Politika privatnosti (Profil): panel za čitanje, tekst nepromijenjen.
function PrivacyPolicy({ onClose }) {
  return (
    <Sheet tall z={1200} onClose={onClose}
      head={<div className="adm-sh"><div className="adm-main"><h3>Politika privatnosti</h3><p>Posljednje ažuriranje: siječanj 2025.</p></div></div>}
      footer={<button type="button" className="adm-btn primary" onClick={onClose}>Razumijem</button>}
    >
      <div className="pp-text">
          <section className="pp-sec">
          <h3>1. Uvod i identitet voditelja obrade</h3>
          <p>Ova Politika privatnosti opisuje kako Dobrovoljno vatrogasno društvo "Bukovac", IX. Bukovački ogranak 2, Zagreb (u daljnjem tekstu: "DVD Bukovac" ili "mi") prikuplja, koristi i štiti osobne podatke korisnika interne aplikacije Koordinapp.</p>
          <p>Aplikacija Koordinapp isključivo je interna aplikacija namijenjena članovima DVD Bukovac za koordinaciju zadataka, intervencija i komunikaciju unutar društva.</p>
        </section>

        <section className="pp-sec">
          <h3>2. Koje osobne podatke prikupljamo</h3>
          <p>U sklopu korištenja aplikacije prikupljamo sljedeće osobne podatke:</p>
          <ul>
            <li><strong>Identifikacijski podaci:</strong> ime i prezime, adresa e-pošte</li>
            <li><strong>Podaci o aktivnosti:</strong> sudjelovanje na zadacima i intervencijama, status prisutnosti, radni status</li>
            <li><strong>Tehnički podaci:</strong> token za push obavijesti, podaci o prijavi (datum, IP adresa)</li>
            <li><strong>Medijski sadržaj:</strong> fotografije lokacija intervencija koje korisnici učitavaju, privici na zadacima</li>
          </ul>
        </section>

        <section className="pp-sec">
          <h3>3. Svrha i pravna osnova obrade</h3>
          <p>Osobni podaci obrađuju se isključivo u svrhu:</p>
          <ul>
            <li>Koordinacije zadataka i intervencija unutar DVD Bukovac</li>
            <li>Slanja push obavijesti o hitnim intervencijama i zadacima</li>
            <li>Evidentiranja sudjelovanja članova na aktivnostima društva</li>
            <li>Interne komunikacije i organizacije rada</li>
          </ul>
          <p>Pravna osnova za obradu je <strong>legitimni interes voditelja obrade</strong> (čl. 6. st. 1. toč. f) Uredbe (EU) 2016/679 – GDPR) te <strong>izvršavanje ugovora</strong> (članstvo u DVD Bukovac) u skladu s čl. 6. st. 1. toč. b) GDPR-a.</p>
        </section>

        <section className="pp-sec">
          <h3>4. Pohrana i sigurnost podataka</h3>
          <p>Svi podaci pohranjuju se na sigurnom poslužitelju smještenom unutar Europskog gospodarskog prostora (EGP). Poduzimamo odgovarajuće tehničke i organizacijske mjere zaštite uključujući:</p>
          <ul>
            <li>Enkripciju podataka u prijenosu (HTTPS/TLS)</li>
            <li>Zaštitu pristupa lozinkom i autentifikacijom</li>
            <li>Ograničen pristup podacima samo ovlaštenim osobama</li>
            <li>Redovite sigurnosne kopije podataka</li>
          </ul>
        </section>

        <section className="pp-sec">
          <h3>5. Dijeljenje podataka s trećim stranama</h3>
          <p>Vaši osobni podaci <strong>ne dijele se s trećim stranama</strong> u komercijalne svrhe. Podaci se mogu proslijediti isključivo:</p>
          <ul>
            <li><strong>Firebase (Google LLC):</strong> isključivo za dostavu push obavijesti, u skladu s njihovom politikom privatnosti i standardnim ugovornim klauzulama EU-a</li>
            <li><strong>Nadležnim tijelima:</strong> isključivo na temelju zakonske obveze ili sudskog naloga</li>
          </ul>
        </section>

        <section className="pp-sec">
          <h3>6. Razdoblje čuvanja podataka</h3>
          <p>Osobni podaci čuvaju se za vrijeme trajanja članstva u DVD Bukovac. Nakon prestanka članstva, podaci se brišu ili anonimiziraju u roku od <strong>90 dana</strong>, osim ako zakonska obveza ne nalaže dulje čuvanje.</p>
          <p>Zapisi o intervencijama i zadacima mogu se čuvati dulje u anonimiziranom obliku u svrhu statističkog praćenja aktivnosti društva.</p>
        </section>

        <section className="pp-sec">
          <h3>7. Vaša prava</h3>
          <p>Sukladno GDPR-u, imate pravo na:</p>
          <ul>
            <li><strong>Pristup:</strong> pravo uvida u osobne podatke koji se obrađuju</li>
            <li><strong>Ispravak:</strong> pravo na ispravak netočnih podataka</li>
            <li><strong>Brisanje:</strong> pravo na brisanje podataka ("pravo na zaborav")</li>
            <li><strong>Ograničenje obrade:</strong> pravo na ograničenje obrade u određenim okolnostima</li>
            <li><strong>Prigovor:</strong> pravo na prigovor obradi temeljnoj na legitimnom interesu</li>
            <li><strong>Prenosivost:</strong> pravo na primanje podataka u strojno čitljivom formatu</li>
          </ul>
        </section>

        <section className="pp-sec">
          <h3>8. Kontakt i ostvarivanje prava</h3>
          <p>Za sva pitanja vezana uz obradu osobnih podataka ili ostvarivanje navedenih prava obratite se administratoru aplikacije.</p>
          <p>Također imate pravo podnijeti pritužbu nadležnom nadzornom tijelu — u Republici Hrvatskoj to je <strong>Agencija za zaštitu osobnih podataka (AZOP)</strong>, Selska cesta 136, 10 000 Zagreb, <a href="https://azop.hr" target="_blank" rel="noreferrer">azop.hr</a>.</p>
        </section>

        <section className="pp-sec">
          <h3>9. Izmjene politike privatnosti</h3>
          <p>DVD Bukovac zadržava pravo izmjene ove Politike privatnosti. O značajnim izmjenama korisnici će biti obaviješteni putem aplikacije. Nastavak korištenja aplikacije nakon objave izmjena smatra se prihvaćanjem izmijenjene politike.</p>
        </section>

        <p className="pp-foot">Ova politika privatnosti izrađena je u skladu s Uredbom (EU) 2016/679 Europskog parlamenta i Vijeća (GDPR) i Zakonom o provedbi Opće uredbe o zaštiti podataka (NN 42/2018).</p>
      </div>
    </Sheet>
  );
}

export default PrivacyPolicy;
